import React from "react";
import Text from "../../../atoms/text/Text";
import InlineGroup from "../../../atoms/inlinegroup/InlineGroup";
import Image from "../../../atoms/image/Image";
import "./ResultsHeader.scss";

interface Props {
  round: number;
  logo?: string;
  gameName?: string;
}

const ResultsHeader: React.FC<Props> = ({ logo, gameName, round }) => {
  return (
    <>
      <InlineGroup block className="results-header-top">
        <div></div>
      </InlineGroup>
      <InlineGroup block verticalCenter className="results-header-bottom">
        <div className="results-summary-header">
          <InlineGroup className="results-summary-block" center verticalCenter>
            <Text size="3xl" colour="white">
              ROUND {round} SUMMARY
            </Text>
          </InlineGroup>
        </div>
        <div className="results-logo-header">
          <InlineGroup
            verticalCenter
            spaceBetweenElements={2}
            style={{ float: "right" }}
            className="pr-2"
          >
            <Image src={logo} alt="default logo" heightSize={12}></Image>
            <Text size="md" className="w-56" bold>
              {gameName}
            </Text>
          </InlineGroup>
        </div>
      </InlineGroup>
    </>
  );
};

export default ResultsHeader;
